import {Button, Center, createStyles, Group, Loader} from '@mantine/core';
import React from 'react';

import FileBrowserActions from 'file-browser/FileBrowserActions';
import {StudyQueryErrorBanner} from 'studies/typed/utils/ui/StudyQueryBanners';
import getTestProps from 'test/lib/cypress/getTestProps';

import PMEIParameterTables from './PMEIParameterTables';
import {PMEISidepanelDetailData} from './usePMEISidepanelDetail';

const useStyles = createStyles((theme) => ({
  worksheetButtonRow: {
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    borderTop: `1px solid ${theme.colors.gray[2]}`,
    borderBottom: `1px solid ${theme.colors.gray[2]}`,
  },
  worksheetButton: {
    color: theme.white,
    textDecoration: 'none',
    '&:hover, &:visited, &:active, &:focus': {
      color: theme.white,
      textDecoration: 'none',
    },
  },
  tablesContainer: {
    padding: theme.spacing.md,
  },
  loadingContainer: {
    flex: 1,
  },
}));

export default function PMEISidePanelContent({
  detailData,
  loading,
  onNavigateToPmei,
}: {
  detailData: PMEISidepanelDetailData | null;
  loading: boolean;
  onNavigateToPmei: ((pmeiId: string) => void) | null;
}): JSX.Element {
  const {classes} = useStyles();

  if (loading) {
    return (
      <Center
        className={classes.loadingContainer}
        {...getTestProps({component: 'PMEISidePanelContent', element: 'loading'})}
      >
        <Loader />
      </Center>
    );
  } else if (detailData == null || detailData.parameterData == null) {
    return <StudyQueryErrorBanner />;
  }

  return (
    <div {...getTestProps({component: 'PMEISidePanelContent', element: 'root'})}>
      {detailData.worksheetId != null && (
        <Group position="right" className={classes.worksheetButtonRow}>
          <Button
            variant="primary"
            size="sm"
            className={classes.worksheetButton}
            onClick={() => {
              FileBrowserActions.openFile(detailData.worksheetId!);
            }}
            {...getTestProps({component: 'PMEISidePanelContent', element: 'openWorksheetButton'})}
          >
            Open Worksheet {detailData.worksheetDisplayId}
          </Button>
        </Group>
      )}
      {detailData?.parameterData && (
        <div className={classes.tablesContainer}>
          <PMEIParameterTables
            parameterData={detailData.parameterData}
            downstreamIndex={detailData.downstreamIndex}
            originIndex={detailData.originIndex}
            onNavigateToPmei={onNavigateToPmei}
            worksheetId={detailData.worksheetId}
          />
        </div>
      )}
    </div>
  );
}
